module.exports = __webpack_public_path__ + "media/src/fonts/GothamPro-670fa0ddcd1729021fdb529b29742df3.woff2";